import { cloneDeep } from 'lodash';
import { api } from '../../../services/api';
import { snakeCase } from '../../base/common/utils';

class AuctionConfigService {
	constructor() {
		this.Api = api;
		this.endpoint = '/api/v0/auction_config/distribution/';
	}

	/* API calls */
	getPublishers() {
		return this.Api.get('/api/v0/publishers/').then((resp) => {
			return resp.data.data;
		});
	}

	getAuctionDistributions() {
		return this.Api.get(this.endpoint).then((resp) => {
			return resp.data.data;
		});
	}

	saveAuctionDistributions(distributions) {
		return this.Api.post(this.endpoint, distributions);
	}

	removePublisherOverride(pubId) {
		return this.Api.delete(this.endpoint, {pub_id: pubId});
	}

	/* Component functions */
	getDistributionData(algorithms) {
		// Split global and publisher distributions
		const [globalDistributions, publisherDistributions] = cloneDeep(algorithms)
			.reduce(([globalDist, pubDist], algo) => {
				return algo.pub_id === null ? [[...globalDist, algo], pubDist] :
					[globalDist, [...pubDist, algo]];
			}, [[], []]);

		// Create a mapping to unique pub_id key {1002: {}, 1003: {}, ...}
		const pubAlgos = publisherDistributions.map((algo) => algo.pub_id)
			.filter((value, index, self) => value && self.indexOf(value) === index)
			.reduce((result, pubId) => {
				result[pubId] = {};
				return result;
			}, {});

		publisherDistributions.forEach((algorithm) => {
			Object.assign(pubAlgos[algorithm.pub_id],
				{[snakeCase(algorithm.algorithm_name)]: algorithm.distribution_fraction});
		});

		return [globalDistributions, pubAlgos];
	}

	getPublisherDisplayed(publishers, pubId) {
		const publisher = publishers.find((publisher) => {
			return publisher.pub_id === pubId;
		});
		return publisher;
	}
}

export default new AuctionConfigService();
